export const MediaType = {
    image: ["png", "PNG", "jpeg", "jpg", "gif", "tiff", "tif", "bmp", "JPG", "svg"],
    video: ["mp4", "avi", "flv", "mpg", "mpeg", "m2v", "m4v", "mov", "wmv", "qt", "mov"],
    audio: ["mp3", "wav", "wma"],
    page: ["docx", "ai", "psd", "eps", "indd", "ind"],
    drawing: ["dwg", "dxf"],
    misc: ["xls", "xlsx", "ppt", "pptx", "doc", "docx", "csv", "txt", "html", "html", "pdf"],
};
